import React from "react";
import ReportsCriteria from './ReportsCriteria';
import * as Bootstrap from 'bootstrap/dist/js/bootstrap.js';
import $ from "jquery";
import {
	getGraphColours,
	getRandomInt,
	strstr
} from './Utilities';
import reactCSS from 'reactcss'
import { ChromePicker } from 'react-color';


const md5 = require('md5');

class ColorPicker extends React.Component {
	constructor(props){
        super(props);

        var defaults = getGraphColours();
		this.state = {
			displayColorPicker: false,
			color: this.props.Color ? this.props.Color : defaults[getRandomInt(5)],
		};
	}

	handleClick = () => {
		this.setState({ displayColorPicker: !this.state.displayColorPicker })
	};

	handleClose = () => {
		this.setState({ displayColorPicker: false })
	};

	handleChange = (color) => {
		this.setState({
			color: color.hex 
		});
	};

	onChange = () => {};//declared to avoid React errors

  	render() {

	    const styles = reactCSS({
			'default': {
				color: {
					width: '36px',
					height: '16px',
					borderRadius: '2px',
					backgroundColor: this.state.color,
				},
				swatch: {
					padding: '5px',
					background: '#fff',
					borderRadius: '1px',
					boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
					display: 'inline-block',
					cursor: 'pointer',
					float: 'left',
					marginTop: '1px'
				},
				popover: {
					position: 'absolute',
					zIndex: '2',
				},
				cover: {
					position: 'fixed',
					top: '0px',
					right: '0px',
					bottom: '0px',
					left: '0px',
				},
				input: {
					float: 'left',
					marginLeft: '10px',
					width: '200px',
				},
				note: {
					clear: 'both'
				}
			},
	    });

	    return (
			<div>
				<div style={styles.swatch} onClick={ this.handleClick}>
				<div style={styles.color} />
			</div>
			<div style={styles.input}>
				<input type="text" name="Color" value={this.state.color} onClick={this.handleClick} onChange={this.onChange} />
			</div>
			<div style={styles.note}>
				<span className="form-text">This color helps identify this favorite in the <a href="/dashboard/favorites">favorites overview</a>.</span>
			</div>
			{this.state.displayColorPicker ? <div style={styles.popover}>
				<div style={styles.cover} onClick={this.handleClose}/>
					<ChromePicker color={this.state.color } onChange={this.handleChange} />
				</div> : null }
			</div>
		);
	}
}

class FavoriteModal extends React.Component {

	constructor(props){
        super(props);

        this.state = {
            values: this.props.values,
            currentFavorite: {},
            color: null
        }	
    }

    componentDidMount(){
    	this.getData();
    }

    getData(){
    	this.setState({
			currentFavorite: this.props.report
		});
    }

    submitForm = (e, form) => {
    	e.preventDefault();
    	if(strstr(window.location.pathname, "results")){
    		$("#FavoriteReportForm").submit();
    	} else {	
	    	var currentFavoriteID = this.state.currentFavorite.ID;
	    	$("#FavoriteReportForm-"+currentFavoriteID).submit();
	    }
    }

    onChange = () => {};//declared to avoid React errors

	render(){
		var currentFavorite = this.state.currentFavorite;
		var currentFavoriteID = (Object.keys(this.state.currentFavorite).length > 0) ? this.state.currentFavorite.ID : "";
		var currentFavoriteName = (Object.keys(this.state.currentFavorite).length > 0) ? this.state.currentFavorite.Name : "";
		var currentFavoriteColor = (Object.keys(this.state.currentFavorite).length > 0) ? this.state.currentFavorite.Color : "";
		var key = (Object.keys(this.state.currentFavorite).length > 0) ? currentFavorite.Hash : md5(new Date());
		var headerText = (Object.keys(this.state.currentFavorite).length > 0) ? "Edit your favorite report" : "Favorite your report";
		var buttonText = (Object.keys(this.state.currentFavorite).length > 0) ? "Update" : "Save";

		//differentiate between modals if more than one on page eg Favorites index page
		var modalID = strstr(window.location.pathname, "results") ? "FavoriteReportModal" : "FavoriteReportModal-"+currentFavoriteID;
		var formID = strstr(window.location.pathname, "results") ? "FavoriteReportForm" : "FavoriteReportForm-"+currentFavoriteID;
		
		var reportFilters = this.state.values;
		if(reportFilters && reportFilters.constructor.name === "Object") reportFilters = JSON.stringify(reportFilters);

		return (
			<div key={key+currentFavoriteID} id={modalID} className="modal fade " tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
			    <div className="modal-dialog">
			        <div className="modal-content">
			            <form key={key} id={formID} method="POST" action={"/ReportsPage_Controller/saveFavoriteReport/"+currentFavoriteID} method="POST">
			                <div className="modal-header">
			                    <h4 className="modal-title">{headerText}</h4>
			                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			                </div>
			                <div className="modal-body p-3">
			                    <div className="row">
			                        <div className="col-12">
			                            <div className="mb-3">
			                                <label className="form-label">Name</label>
			                                <input type="text" className="form-control" name="Name" id="field-favorite-1" 
			                                	placeholder={"My Report"}
			                                	defaultValue={currentFavoriteName} 
			                                	onChange={this.onChange}
			                                />
			                            </div>
			                        </div>
			                        <div className="col-12">
			                            <div className="mb-3">
			                                <label className="form-label">Description</label>
			                                <textarea className="form-control" id="Description" name="Description" 
			                                	placeholder="So you can identify your Favorite easily later." rows="5"
			                                	defaultValue={currentFavorite.Description}>
			                                </textarea>
			                            </div>
			                        </div>
			                        <div className="col-12">
			                            <div className="mb-3">
			                                <ColorPicker Color={currentFavoriteColor}/>
			                            </div>
			                        </div>
			                    </div>

			                    <div className="row">
						            <div className="col-lg-12 mb-2">
						                <div className="ae-accordion ae-accordion-flush" id="ReportCriteriaSoFar">
						                    <div className="ae-accordion-item">
						                        <h2 className="accordion-header" id="flush-headingOne">
						                            <button className="accordion-button show" type="button">
						                                <i className="ae-arrow"></i>
						                                Your criteria so far
						                            </button>
						                        </h2>
						                        <div className="ae-accordion-collapse show criteria-holder mt-3">
						                            <div className="ae-accordion-body criteria">  
						                                <ReportsCriteria Page="Favorites" />
						                            </div>
						                        </div>
						                    </div>
						                </div>
						            </div>
						        </div>

			                </div>

			                <input type="hidden" name="ReportFilters" value={reportFilters} onChange={this.onChange} />

			                <div className="modal-footer">
			                    <button type="button" className="btn btn-light waves-effect float-start" data-bs-dismiss="modal">Close</button>
			                    <a className="btn btn-primary waves-effect waves-light float-end save-favorite" 
			                    	onClick={this.submitForm.bind(this)}>{buttonText}</a>
			                </div>
			            </form>
			        </div>
			    </div>
			</div>
		);
	}
}

export default FavoriteModal;